import { render, staticRenderFns } from "./DropDownItem.vue?vue&type=template&id=63cc4871&scoped=true&"
import script from "./DropDownItem.vue?vue&type=script&lang=js&"
export * from "./DropDownItem.vue?vue&type=script&lang=js&"
import style0 from "./DropDownItem.vue?vue&type=style&index=0&id=63cc4871&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cc4871",
  null
  
)

export default component.exports